import React from 'react'
import PropTypes from 'prop-types'
import ClassNames from 'classnames'
import { Container } from 'react-bootstrap'
import { get } from 'lodash'
import Slider from 'react-slick'

import Image from 'components/atoms/Image/Image'
import SectionTitle from 'components/molecules/SectionTitle/SectionTitle'

import 'slick-carousel/slick/slick.css'
import './MediaCarousel.scss'

function MediaCarousel({ data }) {
  const { medias, last, sectionTitle } = data
  const setting = {
    dots: false,
    dotsClass: `slick-dots primary`,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          dots: true,
          arrows: false,
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
    ],
  }

  return (
    <div className={ClassNames('media-carousel bg-gray-400 section-spacing', { 'section-spacing-last': last })}>
      <Container>
        {sectionTitle && <SectionTitle title={sectionTitle} className="mb-4" />}
        <Slider {...setting}>
          {medias?.map(({ entity }, index) => (
            <Image
              key={get(entity, 'uuid') + get(entity, 'images.medium.url') + index}
              alt={get(entity, 'images.alt')}
              className="media-carousel__image"
              src={get(entity, 'images.medium.url')}
            />
          ))}
        </Slider>
      </Container>
    </div>
  )
}

MediaCarousel.defaultProps = {
  medias: [],
}

MediaCarousel.propTypes = {
  last: PropTypes.bool,
  sectionTitle: PropTypes.string,
}

export default MediaCarousel
